import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Paginated } from '../models/error-tracking.model';
import {
  Transaction,
  TransactionDetail,
  TransactionFilters,
  TracingStats,
} from '../models/tracing.model';
import { UrlConstantsService } from './url-constants.service';

@Injectable()
export class TracingService {
  constructor(
    private _http: HttpClient,
    private urls: UrlConstantsService
  ) {}

  public getTransactions(
    projectId: string,
    filters: TransactionFilters = {}
  ): Observable<Paginated<Transaction>> {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return this._http.get<Paginated<Transaction>>(this.urls.TRANSACTIONS(projectId), { params });
  }

  public getTransaction(projectId: string, transactionId: string): Observable<TransactionDetail> {
    return this._http.get<TransactionDetail>(this.urls.TRANSACTION_BY_ID(projectId, transactionId));
  }

  public getStats(projectId: string): Observable<TracingStats> {
    return this._http.get<TracingStats>(this.urls.TRACING_STATS(projectId));
  }

  /** Every transaction recorded under one trace id - how an error links to its request. */
  public getTrace(projectId: string, traceId: string): Observable<Transaction[]> {
    return this._http.get<Transaction[]>(this.urls.TRACE_BY_ID(projectId, traceId));
  }
}
